import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=3c160a9a&scoped=true&lang=pug"
import script from "./ProductSelector.vue?vue&type=script&lang=js"
export * from "./ProductSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c160a9a",
  null
  
)

export default component.exports